import React, { useEffect, useState } from 'react';
import './App.css';

import Info from '../data/fall2023/info.json';
import Buildings from '../data/buildings.json'
import Classroom from '../models/classroom';

import DateTimePicker from 'react-datetime-picker';

import Header from '../components/header/header';
import Roomtile from '../components/roomtile/roomtile';


function App() {
	let buildings: Object = Buildings;

	//list of all expanded schedulesx
	const [shownSchedules, setShownSchedules] = useState({});
	const toggleSchedules = (id: string) => {
		setShownSchedules(prevShown => ({
			...prevShown,
			[id]: !prevShown[id as keyof typeof prevShown]
		}));
	};

	let days = ["X", "M", "T", "W", "R", "F", "S"];
	let now = new Date();
	let [selectedTime, setSelectedTime] = useState<Date>(new Date());
	let [selectedDay, setSelectedDay] = useState<string>(days[new Date().getDay()]);
	let [selectedHour, setSelectedHour] = useState<string>(String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0'));

	let [emptyClasses, setEmptyClasses] = useState<Classroom[]>([]);
	let [currentTag, setCurrentTag] = useState<string>('');
	let [currentQuery, setCurrentQuery] = useState<string>('');

	//sets the current time states, and refreshes other states
	function createTime(time: Date) {


		let day = days[time.getDay()];
		let hour = String(time.getHours()).padStart(2, '0') + ':' + String(time.getMinutes()).padStart(2, '0');

		setSelectedDay(day);
		setSelectedHour(hour);
		setSelectedTime(time);

		//if tag is in use, then refetch classes for that tag
		if (currentTag !== '') {
			fetchClasses(currentTag);
		}

	}

	useEffect(() => {
		console.log(currentTag)
		if (currentTag !== '') {
			fetchClasses(currentTag);
		}
	}, [selectedTime, selectedDay, selectedHour, currentTag]);

	function fetchClasses(tag: string) {
		setCurrentTag(tag);
		setEmptyClasses([]);
		setCurrentQuery('');

		let rooms = Info[tag as keyof typeof Info];
		for (let room of Object.entries(rooms)) {

			let roomnumber = room[0];
			let roomtimes = room[1];

			let classroom = createClassroom(roomtimes, roomnumber);

			setEmptyClasses(previous => [...previous, classroom]);
		}
	}

	function fetchClassesFromSearch(query: string) {
		setCurrentTag('');
		setEmptyClasses([]);
		//setShownSelector('');

		//query is in the form of "XYZ 123, this searches for buildings that start with the first letters of the query"
		if (query.length <= 3) {
			//return the keys (buildings) of Info that start with the query
			for (let building of Object.keys(Info)) {
				if (building.startsWith(query)) {
					//get all the sub objects (rooms) of Info that start with query
					let rooms = Info[building as keyof typeof Info];
					for (let room of Object.entries(rooms)) {

						let roomnumber = room[0];
						let roomtimes = room[1];
						let classroom = createClassroom(roomtimes, roomnumber);
						setEmptyClasses(previous => [...previous, classroom]);
					}

				}
			}
		} else {
			//gets the building code from the query, its always the first 3 letters
			let building = query.substring(0, 3);

			//gets all the rooms in that building
			let rooms = Info[building as keyof typeof Info];

			//iterates through each room and if the room (and number) starts with the query, add it to the list
			for (let room of Object.keys(rooms)) {
				if (room.startsWith(query)) {

					let roomtimes: any = rooms[room as keyof typeof rooms];
					let roomnumber = roomtimes[0]["classroom"];
					let classroom = createClassroom(roomtimes, roomnumber);
					setEmptyClasses(previous => [...previous, classroom]);
				}
			}
		}
	}

	function createClassroom(roomtimes: any, roomnumber: string) {

		/* creates a classroom object for the room given, and sets its avaliability based
		on the current selectedHour and current selectedDay of the week*/

		let classroom = new Classroom(roomnumber);

		for (let roomtime of roomtimes) {

			//checks if the room is in use at the current day, then checks if the room is in use at the current time
			if (roomtime.days.includes(selectedDay)) {
				if (selectedHour > roomtime.start_army && selectedHour < roomtime.end_army) {
					classroom.avaliable = false;
				}

				//adds the classrooms properties to the classroom object
				classroom.addStartInterval(roomtime.start_army);
				classroom.addEndInterval(roomtime.end_army);
				classroom.addInterval([roomtime.start_army, roomtime.end_army]);
			}
		}

		classroom.sortIntervals();
		classroom.setUntil(selectedHour);

		return classroom;
	}


	return (
		<div className="App">
			<Header />

			<div className='main'>
				<div className='functionality'>
					<div className='selector-bar'>
						<div className='datetime'>
							<div>
								<DateTimePicker
									calendarClassName={'calendar'}
									className={'datetimepicker'}
									onChange={(val) => { createTime(val) }} value={selectedTime}
									disableClock={true}
									clearIcon={null}

								/>
							</div>
						</div>
						<div className='buildings'>
							{
								Object.entries(buildings).map(([building_name, tag]) => {
									return (
										<div className='selections' key={tag}>
											<div
												className={currentTag == tag ? 'building-select red' : 'building-select'}
												onClick={() => { fetchClasses(tag); }}>
												{building_name}
											</div>
										</div>
									)
								})
							}
						</div>
						<div className='searchbar'>
							<input type='text' placeholder='Search for a building - ex: "CDS 101"'
								onChange={
									(e) => { 
										fetchClassesFromSearch(e.target.value.toUpperCase()); 
										setCurrentQuery(e.target.value.toUpperCase()); 
									}
								}
								value={currentQuery}
							/>
						</div>
					</div>
					{
						emptyClasses.length != 0 
						? 
						<div className='classes'>
							<div className='list'>
								{
									emptyClasses.sort((a, b) => (a.avaliable == false) ? 1 : -1).map((v: Classroom) => {

										return <>
											<Roomtile
												v={v}
												key={v.roomnumber}
												_toggleSchedules={toggleSchedules}
												_shownSchedules={shownSchedules}
												_selectedTime={selectedTime}
											/>
										</>
									})
								}
							</div>
						</div> 
						: ''
					}
				</div>
			</div>
		</div>
	);
}

export default App;
